import { getYearStart } from "@wojtekmaj/date-utils";

import TileGroup from "../TileGroup";
import Year from "./Year";

import { getBeginOfDecadeYear } from "../shared/dates";

export default function Years(props) {
  const {
    activeStartDate,
    hover,
    showNeighboringDecade,
    value,
    valueType,
    ...otherProps
  } = props;
  const start = getBeginOfDecadeYear(activeStartDate);
  const end = start + (showNeighboringDecade ? 11 : 9);

  return (
    <TileGroup
      className="react-calendar__decade-view__years"
      dateTransform={getYearStart}
      dateType="year"
      end={end}
      hover={hover}
      renderTile={({ date, ...otherTileProps }) => (
        <Year
          key={date.getTime()}
          {...otherProps}
          {...otherTileProps}
          activeStartDate={activeStartDate}
          currentDecade={start}
          date={date}
        />
      )}
      start={start}
      value={value}
      valueType={valueType}
    />
  );
}
